import React from 'react'
import HeroSection from '../HeroSection/HeroSection';
import FeaturesSection from '../FeaturesSection/FeaturesSection';
import FloatingButtons from '../FloatingButtons/FloatingButtons';
import AboutUs from '../AboutUs/AboutUs';
import Counselling from '../Counselling/Counselling';
import Gallery from '../Gallery/Gallery';
import Contact from '../Enquiry/Contact';

export default function Homepage() {
  return (
    <div>
      <HeroSection />
      <FeaturesSection />
      <AboutUs />
      <Counselling />
      <Gallery />
      <Contact />
      <FloatingButtons />
    </div>
  )
}
